import { createSlice } from '@reduxjs/toolkit'

export const UserCoursesStatus = Object.freeze({
    Loading: 'loading',
    Success: 'success',
    Failure: 'failure',
})

const initialState = {
    status: null,
    errorMessage: '',
    courses: [],
}

const userCoursesSlice = createSlice({
    name: 'userCourses',
    initialState,
    reducers: {
        getUserCoursesRequest(state) {
            state.status = UserCoursesStatus.Loading
            state.courses = []
            state.errorMessage = ''
        },
        getUserCoursesRequestSuccess(state, action) {
            return {
                ...state,
                status: UserCoursesStatus.Success,
                ...action.payload,
            }
        },
        getUserCoursesRequestFailure(state, action) {
            state.status = UserCoursesStatus.Failure
            state.errorMessage = action.payload
        },
    },
})

const {
    getUserCoursesRequest,
    getUserCoursesRequestSuccess,
    getUserCoursesRequestFailure,
} = userCoursesSlice.actions

export const userCoursesActions = {
    getUserCoursesRequest,
    getUserCoursesRequestSuccess,
    getUserCoursesRequestFailure,
}

export const userCoursesSelectors = {
    isFetching: state => state.userCourses.status === UserCoursesStatus.Loading,
    hasError: state => state.userCourses.status === UserCoursesStatus.Failure,
    status: state => state.userCourses.status,
    errorMessage: state => state.userCourses.errorMessage,
    courses: state => state.userCourses.courses,
    categories: state => state.userCourses.categories,
}

export default userCoursesSlice.reducer
